import { useEffect, useRef } from "react";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import MoreProgram from "./MoreProgram";

export default function MoreProgramSlide({ data, col, row }) {
  const [maxCount, setMaxCount] = useState(0);
  useEffect(() => {
    setMaxCount(col * row);
  }, [col, row]);
  const img = useRef([]);

  return (
    <Swiper
      grabCursor={true}
      slidesPerView={1}
      className="mySwiper"
      pagination={{ clickable: true }}
      style={{
        width: "100%",
        height: "100%",
        zIndex: "1",
        swiperSwiperPaginationBulletsBullets: {
          bottom: 0,
        },
      }}
    >
      {data.map(
        (swiper, pageIndex) =>
          data.length - maxCount * pageIndex > 0 && (
            <SwiperSlide
              key={"swiper" + pageIndex}
              className={`grid grid-cols-${col} grid-rows-${row} gap-y-3 gap-x-3 px-5 py-10 box-border w-full`}
            >
              {data.map(
                (pro, index) =>
                  index - maxCount * pageIndex >= 0 &&
                  index - maxCount * pageIndex < maxCount && (
                    <MoreProgram data={pro} key={index}>
                      <div className="text-center">
                        <div
                          className="transition-transform hover:scale-105 p-1"
                          style={{
                            width: "100%",
                            aspectRatio: "1/1.2",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            className="w-full"
                            src={pro.icon}
                            onError={() => {
                              img.current[index].src = "/img/program/no_img.png";
                            }}
                            ref={(el) => {
                              img.current[index] = el;
                            }}
                            alt=""
                          />
                        </div>
                        <p className="text-xs text-gray-400 mb-1" style={{lineHeight: "110%"}}>
                          {pro.creator ? pro.engName : "영문명"}
                        </p>
                        <p>{pro.creator ? pro.korName : "한글명"}</p>
                      </div>
                    </MoreProgram>
                  )
              )}
            </SwiperSlide>
          )
      )}
    </Swiper>
  );
}
